export const BUDGET_RANGES = [
  { value: "0-25000", label: "₹0 – ₹25K", min: 0, max: 25000 },
  { value: "25000-50000", label: "₹25K – ₹50K", min: 25000, max: 50000 },
  { value: "50000-100000", label: "₹50K – ₹1L", min: 50000, max: 100000 },
  { value: "100000-200000", label: "₹1L – ₹2L", min: 100000, max: 200000 },
  { value: "200000-500000", label: "₹2L – ₹5L", min: 200000, max: 500000 },
  { value: "500000-1000000", label: "₹5L – ₹10L", min: 500000, max: 1000000 },
  { value: "1000000-2000000", label: "₹10L – ₹20L", min: 1000000, max: 2000000 },
  { value: "2000000+", label: "₹20L+", min: 2000000, max: null },
];
